import { useState } from "react";

import {
  accessRightsShape,
  ActionBar,
  ActionBarButtons,
  apiErrorsContain,
  apiShape,
  CreateActionButton,
  handleUnknownErrors,
  intlShape,
  isNotFoundError,
  showError,
  withAccessRights,
  withApi,
  withBrowser,
  withIntl,
  withNotifier,
  withSession,
  withUser,
} from "lcm-iot-commons";
import { FormattedMessage } from "react-intl";
import { technicalUserShape } from "../../shapes/technicalUsersShape";
import TechnicalUserModal from "../TechnicalUsers/TechnicalUserModal";
import EdgeDeviceDetailsTechnicalUserItem from "./EdgeDeviceDetailsTechnicalUserItem";

type OwnProps = {
  initialTechnicalUser?: technicalUserShape;
  intl: intlShape;
  accessRights: accessRightsShape;
  edgeDevice: {
    id?: number;
  };
  api: apiShape;
};

const defaultProps: Partial<OwnProps> = {
  initialTechnicalUser: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function EdgeDeviceDetailsTechnicalUser({
  api,
  intl,
  accessRights,
  edgeDevice,
  initialTechnicalUser,
}: Props) {
  const [technicalUser, setTechnicalUser] = useState(initialTechnicalUser);
  const [isCreating, setIsCreating] = useState(false);
  const [showTechnicalUserModal, setShowTechnicalUserModal] = useState(false);

  const createTechnicalUser = async () => {
    setIsCreating(true);
    try {
      const technicalUserCreated = await api.post(
        `/edm/edge_devices/${edgeDevice.id}/technical_users`,
      );
      setTechnicalUser(technicalUserCreated);
      setShowTechnicalUserModal(true);
    } catch (apiErrors) {
      setIsCreating(false);
      if (isNotFoundError(apiErrors)) {
        showError(
          intl.formatMessage({
            id: "api.error.technical_user_create.not_found",
          }),
        );
      } else if (apiErrorsContain(apiErrors, "conflict")) {
        showError(
          intl.formatMessage({
            id: "api.error.technical_user_create.conflict",
          }),
        );
      } else {
        handleUnknownErrors(
          apiErrors,
          intl.formatMessage({ id: "api.error.unknown" }),
        );
      }
    }
  };

  const createDisabled = isCreating || !accessRights.canUpdate;

  const onCloseTechnicalUserModal = () => {
    setShowTechnicalUserModal(false);
    setIsCreating(false);
  };

  const technicalUserModal =
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    showTechnicalUserModal && technicalUser.email && technicalUser.password ? (
      <TechnicalUserModal
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; show: true; titleText: string;... Remove this comment to see the full error message
        id="modal-dialog"
        show={showTechnicalUserModal}
        titleText={intl.formatMessage({
          id: "technical_user_modal.create.modal_title",
        })}
        contextBodyText={intl.formatMessage({
          id: "technical_user_modal.create.modal_message",
        })}
        onClose={onCloseTechnicalUserModal}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        username={technicalUser.email}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        password={technicalUser.password}
      />
    ) : null;

  return (
    <div id="edge-device-technical-user" className="row space-before">
      <div className="col-md-12">
        <ActionBar>
          <h2>
            <FormattedMessage id="edge_device_details.technical_user.header" />
          </h2>
          {technicalUser ? null : (
            <ActionBarButtons>
              <CreateActionButton
                // @ts-expect-error TS(2322) FIXME: Type '{ id: string; onClick: () => Promise<void>; ... Remove this comment to see the full error message
                id="create-technical-user-button"
                onClick={createTechnicalUser}
                disabled={createDisabled}
              />
            </ActionBarButtons>
          )}
        </ActionBar>
        {technicalUser && edgeDevice ? (
          // eslint-disable-next-line react/no-unknown-property
          <ul id="technical-user-item-list" className="list">
            <EdgeDeviceDetailsTechnicalUserItem
              key={(technicalUser as $TSFixMe).id}
              // @ts-expect-error TS(2322) FIXME: Type '{ key: any; technicalUser: technicalUserShap... Remove this comment to see the full error message
              technicalUser={technicalUser}
              accessRights={accessRights}
              edgeDevice={edgeDevice}
            />
          </ul>
        ) : (
          <div id="no-technical-users-found">
            <FormattedMessage id="edge_device_details.technical_user.no_user_assigned" />
          </div>
        )}
      </div>
      {technicalUserModal}
    </div>
  );
}

EdgeDeviceDetailsTechnicalUser.defaultProps = defaultProps;

export default withUser(
  // @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<W... Remove this comment to see the full error message
  withIntl(
    withSession(
      withApi(
        withNotifier(
          // @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<W... Remove this comment to see the full error message
          withIntl(
            withBrowser(
              // @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<OwnProps... Remove this comment to see the full error message
              withAccessRights(
                EdgeDeviceDetailsTechnicalUser,
                // @ts-expect-error TS(2345) FIXME: Argument of type '"EDM::EdgeDeviceDetailsTechnical... Remove this comment to see the full error message
                "EDM::EdgeDeviceDetailsTechnicalUser",
              ),
            ),
          ),
        ),
      ),
    ),
  ),
);
